//Since this configuration is missing from the editor I set it here
//Should be moved to the editor

const START_ASSESMENT = "FE.b4a236ac-8c41-42ee-8124-4afa45e55aea";
const PREGNANCY = "FE.0e22f10d-936b-4a6b-9540-f76141cbb10b";
const EMERGENCY = "FE.820c1553-f230-4aec-b2bc-29a7ec93f2a1";

export type InfoMessageConfigType = {
  buttonText: string;
  type: InfoType;
};

export enum InfoType {
  INFO,
  DISCLAIMER,
  EMERGENCY,
}

export const InfoMessageConfig: { [id: string]: InfoMessageConfigType } = {
  [START_ASSESMENT]: {
    buttonText: "START",
    type: InfoType.INFO,
  },
  [PREGNANCY]: {
    buttonText: "OK",
    type: InfoType.DISCLAIMER,
  },
  [EMERGENCY]: {
    buttonText: "EMERGENCY_CONTINUE_BUTTON",
    type: InfoType.EMERGENCY,
  },
};
